module.exports = __webpack_public_path__ + "46dadfad97c41afdd797790b167da64b.jpg";